module.exports = __webpack_public_path__ + "static/Grupo5952-24589956e5ff352d05dce7bf21c040ff.png";